import { useState, useEffect } from "react";

const scrollTo = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
};

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
    // Mount-only effect; setScrolled is stable.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-40 transition-all duration-300 ${
        scrolled ? "backdrop-blur-xl bg-black/60 border-b border-white/10" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between h-16">
        <button
          onClick={() => scrollTo("top")}
          className="flex items-center gap-2 group"
          data-testid="header-logo"
        >
          <span className="relative inline-flex items-center justify-center w-8 h-8 rounded-lg bg-gradient-to-br from-[#007AFF] via-[#00F0FF] to-[#8B5CF6] shadow-[0_0_20px_rgba(0,240,255,0.5)]">
            <span className="w-2 h-2 rounded-sm bg-black/60" />
          </span>
          <span className="font-display text-xl font-semibold tracking-tight">Vyomex</span>
        </button>
        <nav className="hidden md:flex items-center gap-8 text-sm text-white/70">
          <button onClick={() => scrollTo("problem")} className="hover:text-white transition" data-testid="nav-problem">Problem</button>
          <button onClick={() => scrollTo("solution")} className="hover:text-white transition" data-testid="nav-solution">Solution</button>
          <button onClick={() => scrollTo("process")} className="hover:text-white transition" data-testid="nav-process">Process</button>
          <button onClick={() => scrollTo("testimonials")} className="hover:text-white transition" data-testid="nav-testimonials">Results</button>
          <button onClick={() => scrollTo("faq")} className="hover:text-white transition" data-testid="nav-faq">FAQ</button>
        </nav>
        <button
          onClick={() => scrollTo("contact")}
          className="btn-primary text-sm"
          data-testid="header-cta"
        >
          Get Started
        </button>
      </div>
    </header>
  );
}
